<template lang="pug">
el-card.payment-form(v-show="shouldShow", v-loading.body="loading", :class="formClasses")
  .cf(slot="header")
    h2.fl(v-if="record.type") {{ consts.paymentType[record.type].title }} {{ consts.paymentDocument[record.document].title }}

    el-dropdown.fr(v-if="!isNew && record.type == 1 && record.document != 2", split-button, trigger="click", @click="printInvoice('bg', 'html')", style="margin-left: 20px")
      span Отпечатай фактура
      el-dropdown-menu(slot="dropdown")
        el-dropdown-item(@click.native="printInvoice('bg', 'html')") Фактура HTML
        el-dropdown-item(@click.native="printInvoice('bg', 'pdf')") Фактура PDF
        el-dropdown-item(@click.native="printInvoice('en', 'html')") Invoice HTML
        el-dropdown-item(@click.native="printInvoice('en', 'pdf')") Invoice PDF

    el-dropdown.fr(v-if="!isNew && record.type == 1 && record.document != 2 && Contragent.email && Contragent.eInvoice", trigger="click", style="margin-left: 20px")
      el-button(type="warning")
        | Изпрати email
        i.el-icon-caret-bottom.el-icon--right
      el-dropdown-menu(slot="dropdown")
        el-dropdown-item(@click.native="emailInvoice('bg', 'pdf')") Фактура PDF ({{ Contragent.email }})
        el-dropdown-item(@click.native="emailInvoice('en', 'pdf')") Invoice PDF ({{ Contragent.email }})

    .fr(v-if="!isNew")
      el-button(v-if="record.document == 1 && !record.RefId", @click="createNotice") Създай Кредитно Известие
      el-button(v-if="record.document == 1 && record.RefId", @click="goToRef") Виж Кредитното известие
      el-button(v-if="record.document == 3 && record.RefId", @click="goToRef") Виж Фактурата


  el-form(label-position="top", ref="form", :model="record", :rules="rules")

    el-row
      el-col(:sm="10")
        el-form-item(prop="ContragentId", label="Контрагент")
          el-select(v-model="record.ContragentId", placeholder="Контрагент (Име/ЕИК/Фирма)", :remote-method="contragentAhead", filterable, remote, :loading="contragentLoading", :disabled="!isNew")
            el-option(v-for="c in contragentOptions", :label="c.text", :value="c.id", :key="c.id")
      el-col(:sm="4")
        el-form-item(label=" ")
          el-button(v-if="record.ContragentId", type="text", icon="el-icon-edit", @click="openContragent") Виж контрагент
          el-button(v-if="!record.ContragentId", type="text", icon="el-icon-plus", @click="openContragent") Въведи нов контрагент
      el-col(:sm="4")
        el-form-item(prop="vatPercent" label="ДДС %" style="max-width: 150px")
          el-input(v-model.number="record.vatPercent" placeholder="")
            template(slot="append") %
      el-col(:sm="6", :offset="0")
        el-form-item(prop="CompanyId", label="Фирма")
          el-select(v-model="record.CompanyId", placeholder="Фирма", @change="changeCompany")
            el-option(v-for="c in companies", :label="c.name", :value="c.id", :key="c.id")

    el-row
      el-col(:sm="6")
        el-form-item.fix-el-form-item-height(v-if="record.document == 1 || record.document == 3", prop="num", label="Докумен №", :rules="{required: this.record.type == 2 }")
          el-input(v-model.number="record.num", type="number")
            template(slot="prepend") {{ numZeros }}
      el-col(:sm="6")
        el-form-item.fix-el-form-item-height(v-if="record.document == 3", label="Към докумен №")
          el-input(:value="Ref.num", :disabled="true")
            template(slot="prepend") {{ numRefZeros }}
      el-col(:sm="6", :offset="6")
        el-form-item(prop="AccountId", label="Банкова сметка")
          el-select(v-model="record.AccountId", placeholder="Банкова сметка", clearable)
            el-option(v-for="a in accounts", :label="a.name", :value="a.id", :key="a.id")

    el-row
      el-col(:sm="6")
        el-form-item(prop="method", label="Начин на плащане")
          el-select(v-model="record.method", placeholder="")
            el-option(v-for="(method, id) in consts.paymentMethod", :label="method.title", :value="parseInt(id)", :key="id")
      el-col(:sm="6")
        el-form-item(prop="status", label="Статус")
          el-select(v-model="record.status", placeholder="")
            el-option(v-for="(status, id) in consts.paymentStatus", :label="status.title", :value="parseInt(id)", :key="id")
      el-col(:sm="6", :offset="6")
        el-form-item(prop="publishedAt", label="Дата на издаване")
          el-date-picker(:value="record.publishedAt", @input="record.publishedAt = modelDate($event)", placeholder="Избери дата")
    el-row
      el-col(:sm="12")
        el-form-item(prop="description", label="Описание на сделката")
          el-input(v-model="record.description", placeholder="Описание")
      el-col(:sm="6", :offset="6")
        el-form-item(prop="dueTo", label="Дата на плащане")
          el-date-picker(:value="record.dueTo", @input="record.dueTo = modelDate($event)", placeholder="Избери дата")


    el-row.subjects-header
      el-col(:sm="14")
        el-dropdown(trigger="click")
          el-button(type="primary")
            span Добави Основание
            i.el-icon-caret-bottom.el-icon--right
          el-dropdown-menu(slot="dropdown")
            el-dropdown-item(v-for="(s, id) in consts.subjectType[record.type]", @click.native="addSubject(parseInt(id))", :key="id") {{ s.title }}
      el-col(:sm="2", v-if="hasSubjects"): small Кол.
      el-col(:sm="3", v-if="hasSubjects"): small Цена
      el-col(:sm="2", v-if="hasSubjects"): small Отст. %
      el-col(:sm="3", v-if="hasSubjects"): small Сума

    subject-form(v-for="(subject, index) in record.Subjects", :payment="record", :subject="subject", :index="index", :key="index")

    el-row(v-if="hasSubjects")
      el-col(:sm="3", :offset="15")
        el-form-item(label="Преди ДДС")
          el-input.tr(:value="price | formatPrice", :disabled="true")
            template(slot="append") лв.
      el-col(:sm="3")
        el-form-item(label="ДДС")
          el-input.tr(:value="priceVAT | formatPrice", :disabled="true")
            template(slot="append") лв.
      el-col(:sm="3")
        el-form-item(label="Крайна сума")
          el-input.tr(:value="priceTotal | formatPrice", :disabled="true")
            template(slot="append") лв.

    .form-actions.cf
      el-button.fl(type="text", icon="el-icon-arrow-left", @click="$router.push(url)") Назад към списъка
      el-button.fr(type="primary", @click="onSubmit") {{ isNew ? 'Създай' : 'Запази' }}
      el-button.fr(v-if="record.id", type="danger", @click="onDelete") Изтрий

  email-invoice-dialog(ref="emailInvoiceDialog")
</template>

<script>
import formMixin from '../mixins/formMixin.js'
import SubjectForm from './SubjectForm.vue'
import EmailInvoiceDialog from './EmailInvoiceDialog.vue'

export default {
  name: 'PaymentForm',
  mixins: [formMixin],
  props: {},
  data () {
    const validateAccountId = (rule, value, callback) => {
      if (this.record.method === 1 && !value) {
        callback(new Error('Пилето е задължително'))
      } else {
        callback()
      }
    }

    return {
      apiUrl: '/payments',
      url: '/payments',
      loading: true,
      Contragent: null,
      Company: null,
      Ref: null,
      record: {
        id: null,
        type: null,
        document: null,
        ContragentId: null,
        CompanyId: null,
        AccountId: null,
        RefId: null,
        num: null,
        publishedAt: this.getInitialPublishedAt(),
        method: null,
        status: null,
        dueTo: this.getInitialDueTo(),
        description: null,
        vatPercent: null,
        price: null,
        priceVat: null,
        priceTotal: null,
        Subjects: []
      },
      rules: {
        ContragentId: {required: true, message: 'Полето е задължително'},
        CompanyId: {required: true, message: 'Полето е задължително'},
        AccountId: {validator: validateAccountId}, // {reqiured: false, type: 'integer', message: 'Полето е задължително'},
        status: {required: true, message: 'Полето е задължително'},
        method: {required: true, message: 'Полето е задължително'},
        publishedAt: {required: true, message: 'Полето е задължително'},
        dueTo: {required: true, message: 'Полето е задължително'},
        vatPercent: [
          {required: true, message: 'Полето е задължително'},
          { type: 'number', max: 100, min: 0, message: 'Число от 0 до 100' }
        ],
      },
      contragentOptions: [],
      contragentLoading: false
    }
  },
  computed: {
    companies () {
      return this.$auth.check() ? this.$auth.user().tables.companies : []
    },
    company () {
      return this.record.CompanyId ? this.$auth.user().tables.companies.find(c => c.id === this.record.CompanyId) : null
    },
    accounts () {
      return this.$auth.check() ? this.$auth.user().tables.accounts : []
    },
    formClasses () {
      return ['type-' + this.record.type, 'document-' + this.record.document]
    },
    isNotice () {
      return this.record.type == 3 ? true : false
    },
    hasSubjects () {
      return this.record.Subjects.length > 0
    },
    price () {
      const sum = this.record.Subjects.reduce((sum, s) => sum + this.common.subjectPriceTotal(s), 0)
      if (this.record.vatPercent) {
        return sum / (1 + this.record.vatPercent / 100)
      } else {
        return sum
      }
    },
    priceVAT () {
      if (this.record.vatPercent) {
        return this.price * this.record.vatPercent / 100
      } else {
        return 0
      }
    },
    priceTotal () {
      return this.price + this.priceVAT
    },
    numZeros () {
      let len = 10
      if (this.record.num) {
        len = 10 - this.record.num.toString().length
      }
      return '0000000000'.substr(0, len)
    },
    numRefZeros () {
      let len = 10
      if (this.Ref.num) {
        len = 10 - this.Ref.num.toString().length
      }
      return '0000000000'.substr(0, len)
    }
  },
  methods: {
    contragentAhead (term, cb) {
      this.contragentLoading = true
      this.$http.get('/ahead/contragent', {params: {term}}).then(response => {
        this.contragentLoading = false
        this.contragentOptions = response.data.results.map(r => {
          r.text = r.name + ' (' + r.eik + ')' + (r.companyName ? ' (' + r.companyName + ')' : '')
          return r
        })
      }).catch(error => {
        console.error(error)
        this.$notify.error({title: 'Error', message: 'Error loading contragents filter. Check console.'});
      })
    },
    onSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.hasSubjects) {
            this.saveRecord()
          } else {
            this.$message({message: 'Моля въведете поне едно основание', type: 'warning'})
          }
        } else {
          this.$message({message: 'Моля попълнете задължителните полета', type: 'warning'})
        }
      })
    },
    loadRecord (id) {
      this.loading = true
      this.$http.get(this.apiUrl + '/' + id).then(response => {
        // this.record = Object.assign({}, this.defaultRecord, response.data)
        this.record = {...this.defaultRecord}
        Object.keys(this.record).forEach(k => {
          this.record[k] = response.data[k]
        })
        this.loading = false

        this.Ref = response.data.Ref

        if (this.record.id) {
          this.Company = response.data.Company
          this.Contragent = response.data.Contragent
          const r = this.Contragent
          this.contragentOptions = [{id: r.id, text: r.name + ' (' + r.eik + ')' + (r.companyName ? ' (' + r.companyName + ')' : '')}]
        }
      }).catch(error => {
        console.error(error)
        this.loading = false
        this.$notify.error({title: 'Error', message: 'Error loading record. Check console.'})
        this.$router.replace(this.url)
      })
    },
    createNotice () {
      this.record.RefId = this.record.id
      this.Ref = {num: this.record.num}
      this.record.document = 3
      this.record.id = null
      this.record.num = null
      this.changeCompany(this.record.CompanyId)
    },
    goToRef () {
      this.$router.push(this.url + '/' + this.record.RefId)
      this.loadRecord(this.record.RefId)
    },
    addSubject (type) {
      const subject = {
        id: null,
        type: type,
        PaymentId: null,
        IssueId: null,
        LiteratureId: null,
        EventId: null,
        subscriptionType: null,
        subscriptionVariant: null,
        year: null,
        month: null,
        delivery: null,
        format: '',
        description: '',
        discount: 0,
        quantity: 1,
        price: 0,
        // priceDiscounted: 0,
        // priceTotal: 0,
      }
      this.record.Subjects.push(subject)
    },
    openContragent () {
      this.$router.push('/contragents/' + (this.record.ContragentId ? this.record.ContragentId : 'new'))
      // window.open('/contragents/' + (this.record.id ? this.record.id : 'new'))
    },
    changeCompany (id) {
      if (!this.record.id && this.record.type === 1) {
        const params = {
          CompanyId: id,
          type: this.record.type,
          document: this.record.document
        }
        this.$http.get('/ahead/num', {params}).then(response => {
          this.record.num = parseInt(response.data)
        }).catch(error => {
          console.error(error)
          this.$notify.error({title: 'Error', message: 'Error loading num. Check console.'})
        })
      }
    },
    printInvoice (lang, format) {
      window.open(`${this.$baseURL}payments/${this.record.id}/invoice?lang=${lang}&format=${format}&token=${this.$auth.token()}`)
    },
    emailInvoice (lang, format) {
      this.$refs.emailInvoiceDialog.show(lang, this.record, this.Company, this.Contragent)
    },
    getInitialPublishedAt () {
      return this.modelDate(new Date())
    },
    getInitialDueTo () {
      var d = new Date()
      d.setDate(d.getDate() + 10)
      return this.modelDate(d)
    }
  },
  created () {
    if (this.$route.params.id === 'new') {
      this.record.type = parseInt(this.$route.query.type)
      this.record.document = parseInt(this.$route.query.document)
    }
  },
  // watch: {
  //   company () {
  //     if (this.company && this.isNew && this.record.document === 1) {
  //       this.record.vatPercent = this.company.withVat ? 0 : this.consts.defaultVatPercent
  //     }
  //   }
  // },
  components: {
    'subject-form': SubjectForm,
    'email-invoice-dialog': EmailInvoiceDialog
  }
}
</script>

<style lang="stylus">
.payment-form
  &.type-1 .el-card__header
    background #f0f9eb
    color #67c23a
  &.type-2 .el-card__header
    background #fef0f0
    color #f56c6c
  // h2
  //   color #fff

  .fix-el-form-item-height .el-form-item__content
    height 36px

.subjects-header
  margin-bottom 10px
  .el-col small
    display block
    margin-top 18px
</style>
